import type { Profession } from 'src/shared/features/users/schemas/profession'
import type { PublicUserData } from 'src/shared/features/users/schemas/user'

export enum TeamInvitationStatus {
  PENDING = 'pending',
  INTERESTED = 'interested',
  APPROVED = 'approved',
  DECLINED_BY_INVITEE = 'declined_by_invitee',
  DECLINED_BY_CONSUMER = 'declined_by_consumer',
  EXPIRED = 'expired',
}

// Team user summary structure
export interface TeamUserSummary {
  userId: number
  userFirstName: string
  userLastName: string
  userProfession: Profession
  userProfilePhoto: string | null
}

// Team invitation list item structure
export interface TeamInvitationListItem {
  teamInvitationId: number
  teamInvitationStatus: TeamInvitationStatus
  role: TeamRole
  userId: number
  userFirstName: string
  userLastName: string
  userProfilePhoto: string | null
  userProfession: Profession
}

// Main team overview response structure
export interface TeamOverview {
  teamId: number
  members: TeamUserSummary[]
  invitationsByProfession: Record<Profession, TeamInvitationListItem[]>
  spectators: TeamUserSummary[]
}

// Team role enum matching backend
export enum TeamRole {
  SPECTATOR = 'spectator',
  MEMBER = 'member',
}

// Team membership structure matching backend TeamMembership schema
export interface TeamMembership {
  role: TeamRole
  profession: Profession
  user: PublicUserData
  joinedAt: string // DateTime as string
}

// TeamInvitationCreate type based on the backend schema
export interface TeamInvitationCreate {
  teamId: number
  inviteeId: number
  role?: TeamRole
}

// TeamInvitation response type based on the backend schema
export interface TeamInvitation {
  id: number
  inviterId: number
  status: string
  createdAt: string
  updatedAt: string
  businessId?: number | null

  inviter: PublicUserData
  invitee: PublicUserData
  team: Team

  teamId: number
  inviteeId: number
  role: TeamRole
}

export interface Team {
  memberships: TeamMembership[]
  id: number
  createdAt: string
  updatedAt: string
  createdByUserId: number
}
